import React from "react";
import { Col, Nav, Row, Tab } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { AiOutlineArrowLeft } from "react-icons/ai";
import { Link, useParams } from "react-router-dom";

import ProfileChangeEmail from "../profile-change-email/profile-change-email.page";

type Props = {};

const ProfileEditPage = (props: Props) => {
  const { t } = useTranslation();
  const param = useParams();

  let selectTab = "EditAccount";

  if (param?.name) {
    selectTab = param?.name;
  }

  return (
    <section className="profile-edit">
      <Row className="m-0">
        <Tab.Container defaultActiveKey={selectTab}>
          <Row className="m-0 p-0">
            <Col lg={3} className="border-end d-none d-md-block p-0">
              <Row className="py-3  border-bottom align-items-center m-0 bg-secondColor">
                <Col className="px-3">
                  <h4 className="m-0  font-sofiaSans fw-bolder fs-3 tw-leading-6">
                    {t("ProfileEditPage/l-01")}
                  </h4>
                </Col>
              </Row>
              <Nav variant="pills" className="d-flex flex-column mt-2">
                <Nav.Item className="px-0">
                  <Nav.Link eventKey="EditAccount">
                    {t("ProfileEditPage/l-02")}
                  </Nav.Link>
                </Nav.Item>
                {/* <Nav.Item className="px-0">
         <Nav.Link eventKey="ChangeEmail">Change my email</Nav.Link>
        </Nav.Item> */}
                <Nav.Item className="px-0">
                  <Nav.Link eventKey="UpdatePassword">
                    {t("ProfileEditPage/l-03")}
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </Col>
            <Col lg={9}>
              <Tab.Content>
                <Tab.Pane eventKey="EditAccount">
                  <Row className="align-items-center">
                    <Col className="py-0">
                      <Row className="border-bottom py-3 px-3 px-md-0 d-flex align-items-end bg-secondColor">
                        <Link to="../profile" style={{ width: "24px" }}>
                          <AiOutlineArrowLeft />
                        </Link>
                        <h4
                          className="m-0 font-sofiaSans fw-bolder fs-3 "
                          style={{ width: "250px" }}
                        >
                          {t("ProfileEditPage/l-04")}
                        </h4>
                      </Row>
                      <Row>
                        <Col>{/* <ProfileInfoEditPage /> */}</Col>
                      </Row>
                    </Col>
                  </Row>
                </Tab.Pane>
                <Tab.Pane eventKey="ChangeEmail">
                  <Row className="  align-items-center">
                    <Col>
                      <Row className="border-bottom py-3 px-3 px-md-0 d-flex align-items-end">
                        <Link to="../profile" style={{ width: "24px" }}>
                          <AiOutlineArrowLeft />
                        </Link>
                        <h4
                          className="m-0 font-sofiaSans fw-bolder fs-3 "
                          style={{ width: "250px" }}
                        >
                          {t("ProfileEditPage/l-05")}
                        </h4>
                      </Row>
                      <Row>
                        <Col>
                          <ProfileChangeEmail />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Tab.Pane>
                <Tab.Pane eventKey="UpdatePassword">
                  <Row className="  align-items-center">
                    <Col>
                      <Row className="border-bottom py-3 px-3 px-md-0 d-flex align-items-end">
                        <Link to="../profile" style={{ width: "24px" }}>
                          <AiOutlineArrowLeft />
                        </Link>
                        <h4
                          className="m-0 font-sofiaSans fw-bolder fs-3 "
                          style={{ width: "250px" }}
                        >
                          {t("ProfileEditPage/l-03")}
                        </h4>
                      </Row>
                      <Row>
                        <Col>{/* <ProfileChangePassword  /> */}</Col>
                      </Row>
                    </Col>
                  </Row>
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      </Row>
    </section>
  );
};

export default ProfileEditPage;
